document.addEventListener('alpine:init', function () {
    Alpine.data('compareVariants', function (defaultVariant) {
        return {
            selectedVariant: defaultVariant,
            selectVariant: function (variant) {
                this.selectedVariant = variant;
                this.$store.app.track({
                    event: "click_element",
                    type: 'click',
                    module: 'compare-variants',
                    data: {
                        variant: variant,
                    },
                });
            },
            variantClasses: function (variant, moduleBackground) {
                return {
                    'border-transparent': this.selectedVariant !== variant,
                    'border-leaf': this.selectedVariant === variant,
                    'bg-satin': this.selectedVariant === variant && moduleBackground === 'white',
                    'bg-white': this.selectedVariant === variant && moduleBackground === 'satin',
                };
            },
        };
    });
});
